module.exports = __webpack_public_path__ + "static/img/brees-2002-slide-1.2961912.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2002-slide-1.jpg
// module id = U+8Z
// module chunks = 1